import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div
  {{on "click" this.onSelectedNameClick}}
  tabindex="0"
  title={{this.title}}
  data-value={{this.value}}
  data-name={{this.name}}
  class="select-kit-selected-name selected-name choice"
>
  <div class="body">
    {{this.badge}}
    {{d-icon "times"}}
  </div>
</div>
*/
{
  "id": "gIS6PrW4",
  "block": "[[[11,0],[24,\"tabindex\",\"0\"],[16,\"title\",[30,0,[\"title\"]]],[16,\"data-value\",[30,0,[\"value\"]]],[16,\"data-name\",[30,0,[\"name\"]]],[24,0,\"select-kit-selected-name selected-name choice\"],[4,[38,0],[\"click\",[30,0,[\"onSelectedNameClick\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"body\"],[12],[1,\"\\n    \"],[1,[30,0,[\"badge\"]]],[1,\"\\n    \"],[1,[28,[35,1],[\"times\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"on\",\"d-icon\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/multi-select/selected-category.hbs",
  "isStrictMode": false
});